import $ from "jquery";

$(() => {
  if (document.querySelector('.listing-search')) {
    const mapParallax = () => {
      const search = $(".svg-container");
      const mapBackground = search.children("svg");
      let maxShift = mapBackground.height() - search.height();  
      let searchTop = search.offset().top;
      let scrollPosition = searchTop - $(window).scrollTop();
      let windowHeight = $(window).height();
      let margin = null;

      if ( scrollPosition <= 0 ) {
        margin = maxShift;
      } else if ( scrollPosition >= windowHeight ) {
        margin = 0;
      } else {
        margin = (1 - (scrollPosition / windowHeight)) * maxShift;
      }

      margin = "-" + margin + "px";
      mapBackground.css("margin-top", margin);
    }

    $(window).on("scroll", function () {
      mapParallax();
    });
    
    const searchButton = $('.search-button');
    const searchField = $('.search-field');

    const gotoSearch = () => {
      const searchInput = '/listings/?es_search%5Baddress%5D=' + encodeURIComponent(searchField.val()) + '&es_search%5Bcity%5D=';
      // console.log(searchInput);
      window.location = searchInput;
    }
    searchButton.on('click', function(){ gotoSearch(); });
  }
});